import type { Board } from "../board";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class WinArea extends PhysicalThing implements ProcessableThing {
	static key = "WinArea";
	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		if (!board.player || !board.player.xy.equals(this.xy)) return;
		if (!board.gameFlags.equationFound) return;
		board.gameFlags.gameWon = true;
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): WinArea {
		const w = new WinArea(deserializeXY(data.xy));
		w.visualId = data.visualId;
		return w;
	}
}
